import { Vendor } from "..";

type ContactEmails = Pick<
  Vendor,
  "primaryContactEmail" | "primaryContactIsSignatory" | "signatoryEmail"
>;

/** The distinct addresses a vendor may route notifications to; mirrors ev-server. */
export const notificationEmailChoices = (
  loginEmail: string,
  vendor: ContactEmails,
): string[] =>
  Array.from(
    new Set(
      [
        loginEmail,
        vendor.primaryContactEmail,
        vendor.primaryContactIsSignatory ? null : vendor.signatoryEmail,
      ]
        .map((email) => email?.trim().toLowerCase())
        .filter((email): email is string => Boolean(email)),
    ),
  );

/** The saved pick while it is still one of the choices, else the login email. */
export const selectedNotificationEmail = (
  loginEmail: string,
  vendor: ContactEmails & Pick<Vendor, "notificationEmail">,
): string => {
  const choices = notificationEmailChoices(loginEmail, vendor);
  const picked = vendor.notificationEmail?.trim().toLowerCase();

  return picked && choices.includes(picked) ? picked : choices[0];
};
